module.exports = __webpack_public_path__ + "fonts/Barlow-Italic.61a68208.eot";